import React from 'react'
import { Collapse } from 'antd'
import { CollapsePanelProps } from 'antd/lib/collapse'
import { Popconfirm } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'
import './styles.css'

const { Panel: AntPanel } = Collapse

interface PanelProps extends CollapsePanelProps {
  header: string
  key: string | number
  index?: number
  deleteButton?:
    | {
        action: () => void
        title: string
        okText?: string
        cancelText?: string
      }
    | false
  children: React.ReactNode
}

const Panel = (props: PanelProps) => {
  const { index, key, deleteButton = false, children, ...rest } = props

  return (
    <AntPanel
      className='panel-border'
      key={`${key}`}
      extra={
        props.extra ||
        (deleteButton && (
          <div
            onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
              event.stopPropagation()
            }>
            <Popconfirm
              placement='leftTop'
              title={deleteButton.title}
              onConfirm={deleteButton.action}
              okText={deleteButton.okText || 'Yes'}
              cancelText={deleteButton.cancelText || 'No'}>
              <CloseCircleOutlined
                style={{ zIndex: 1 }}
                className='panel-btn'
              />
            </Popconfirm>
          </div>
        ))
      }
      {...rest}>
      {children}
    </AntPanel>
  )
}

export default Panel
export type { PanelProps }
